import { render, staticRenderFns } from "./EmployeeAttendanceAdd.vue?vue&type=template&id=061faa88&scoped=true&"
import script from "./EmployeeAttendanceAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeAttendanceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061faa88",
  null
  
)

export default component.exports